package com.htmlagent.site.components.sections

import androidx.compose.runtime.Composable
import com.htmlagent.site.i18n.LocalStrings
import com.htmlagent.site.theme.Icons
import com.htmlagent.site.theme.MobileAppBarEndStyle
import com.htmlagent.site.theme.MobileAppBarStyle
import com.htmlagent.site.theme.MobileAppBarSwitchStyle
import com.htmlagent.site.theme.PanelCloseVariant
import com.htmlagent.site.theme.SegmentActiveStyle
import com.htmlagent.site.theme.SegmentVariant
import com.htmlagent.site.theme.SegmentedStyle
import com.htmlagent.site.theme.Tokens
import com.htmlagent.site.theme.named
import com.htmlagent.site.theme.pressed
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/**
 * The phone's app bar, the same over the conversation and over the page: the menu on the left,
 * the switch between the two in the middle, and the pane's own tools on the right.
 *
 * The switch replaces "View the page" and "Back to the chat", which were two different buttons in
 * two different places. Each pane paints its own copy - only one is ever on screen - so the page's
 * tools stay with the state they need instead of being lifted into the workspace.
 */
@Composable
fun MobileAppBar(
    onPage: Boolean,
    pageAvailable: Boolean,
    onOpenMenu: () -> Unit,
    onShowChat: () -> Unit,
    onShowPage: () -> Unit,
    tools: @Composable () -> Unit = {},
) {
    val t = LocalStrings.current

    Div(MobileAppBarStyle.toModifier().toAttrs()) {
        Div {
            Button(
                onClick = { onOpenMenu() },
                modifier = Modifier.named(t.landing.navOpenMenu),
                variant = PanelCloseVariant,
            ) {
                Glyph(Icons.Menu, size = Tokens.iconSm.value())
            }
        }

        Row(
            SegmentedStyle.toModifier()
                .then(MobileAppBarSwitchStyle.toModifier())
                .attrsModifier { attr("role", "group") },
        ) {
            Button(
                onClick = { onShowChat() },
                modifier = (if (!onPage) SegmentActiveStyle.toModifier() else Modifier).pressed(!onPage),
                variant = SegmentVariant,
                size = ButtonSize.SM,
            ) {
                Text(t.rail.chatTab)
            }
            // A session with no page yet has nothing to switch to; the half stays, disabled.
            Button(
                onClick = { if (pageAvailable) onShowPage() },
                modifier = (if (onPage) SegmentActiveStyle.toModifier() else Modifier)
                    .pressed(onPage)
                    .attrsModifier { if (!pageAvailable) attr("aria-disabled", "true") },
                variant = SegmentVariant,
                size = ButtonSize.SM,
            ) {
                Text(t.rail.pageTab)
            }
        }

        Div(MobileAppBarEndStyle.toModifier().toAttrs()) { tools() }
    }
}
